import { SearchField } from '@eleveo/components-react';
import { FormApi } from 'final-form';
import React from 'react';
import { Form, FormRenderProps, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { SEARCH_SCHEDULE_ELEMENTS_CONTAINER_TAG, getSearchFieldsInputTag } from './constants';
import { useDebouncedField } from '../../utils/useDebounceField';
import { max255chars } from '../../utils/validations';

interface ScheduleElementsHeaderFilter {
  name: string;
}

export type ScheduleElementsHeaderFilterType = Partial<ScheduleElementsHeaderFilter>;

interface ScheduleElementsHeaderSearchFormProps {
  onSubmit: (values: ScheduleElementsHeaderFilterType, form: FormApi<ScheduleElementsHeaderFilterType>) => void;
}

const SearchForm = ({ handleSubmit }: FormRenderProps) => {
  const { t } = useTranslation();

  useFormState<ScheduleElementsHeaderFilter>({
    subscription: { dirty: true, modified: true, values: true },
    onChange: ({ modified }) => {
      // Do not fire on initial render, when updating state is causing React error
      if (modified?.name) {
        handleSubmit();
      }
    },
  });

  const { input } = useDebouncedField('name', {
    validate: max255chars,
  });

  return (
    <form data-test-id={SEARCH_SCHEDULE_ELEMENTS_CONTAINER_TAG}>
      <SearchField
        {...input}
        placeholder={t('filter.search')}
        testId={getSearchFieldsInputTag('schedule-element-name')}
      />
    </form>
  );
};

export const ScheduleElementsHeaderSearchForm: React.FC<ScheduleElementsHeaderSearchFormProps> = ({ onSubmit }) => {
  return <Form onSubmit={onSubmit} component={SearchForm} />;
};
